/**
 * The control styles every select in a GSC tools grid is given.
 *
 * ReactSelect is styled for the toolbars it was first built for, where it stands alone: it carries
 * a 295px minimum width, and react-select's own 38px control. Neither holds in a control grid —
 * there the cell decides the width, or a four-column row overflows the card it sits in, and a
 * 38px control reads as ragged beside the 42px text inputs, date fields and buttons on the same
 * row. Both are set here rather than per call site so one row never drifts from another.
 */
export const GRID_SELECT = { minWidth: 0, minHeight: '42px' };
